import { render, staticRenderFns } from "./Board.vue?vue&type=template&id=438bd9ae&scoped=true"
import script from "./Board.vue?vue&type=script&lang=js"
export * from "./Board.vue?vue&type=script&lang=js"
import style0 from "./Board.vue?vue&type=style&index=0&id=438bd9ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438bd9ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('438bd9ae')) {
      api.createRecord('438bd9ae', component.options)
    } else {
      api.reload('438bd9ae', component.options)
    }
    module.hot.accept("./Board.vue?vue&type=template&id=438bd9ae&scoped=true", function () {
      api.rerender('438bd9ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/Board.vue"
export default component.exports